import axios from "axios";

var baseUrl = process.env.VUE_APP_API_BASE_URL
  ? process.env.VUE_APP_API_BASE_URL
  : window.location.origin;

  let storeUrlPrefix = "";
  const storeViews = process.env.VUE_APP_STORE_VIEWS.split(',');
  // we loop through each storeView url prefix to append it to our api calls if necessary
  storeViews.forEach((value) => {
      if(window.location.href.includes(process.env.VUE_APP_API_BASE_URL+'/'+value+'/')){
          storeUrlPrefix = '/'+value;
      }
  });

if (window.location.origin !== "http://" + process.env.VUE_APP_URL_PREFIX + ".soon") {
  var url = baseUrl;
}

const instanceApi = axios.create({
  baseURL: url+storeUrlPrefix+'/',
  withCredentials: true,
  credentials: "include",
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json;charset=UTF-8",
  },
});

export default instanceApi;
